<template>
  <Layout v-loading="isLoading">
    <template #top>
      <span>
        {{ `当日收入:${totalToday.toFixed(2)}` }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        {{ `前一日收入:${yesterdayToday.toFixed(2)}` }}
      </span>
    </template>
    <template>
      <el-table
        ref="comparisonTable"
        :data="tableData"
        style="width: 100%"
        border
        tooltip-effect="dark"
        :header-cell-style="{ background: '#f4f5f9', color: '#000' }"
      >
        <!-- 游戏名称 -->
        <el-table-column label="游戏名称" width="180">
          <template slot-scope="scope">
            <router-link
              :to="`/home/realization/income?appId=${scope.row.appId}`"
            >
              {{ scope.row.appName }}</router-link
            >
          </template>
        </el-table-column>
        <!-- 更新日期 -->
        <el-table-column label="更新日期" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              formatTime(
                new Date(scope.row.today.createTime),
                "yyyy-MM-dd HH:mm:00"
              )
            }}</span>
          </template>
        </el-table-column>
        <!-- 预估收入 -->
        <el-table-column label="预估收入" width="180">
          <template slot="header" slot-scope="scope">
            <span
              >预估收入
              <a @click="sortData(rawData, 'today', 'money')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'money')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              formatData(scope.row.today.money ?? 0)
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              formatData(scope.row.yesterday.money ?? 0)
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- eCPM -->
        <el-table-column label="eCPM" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >eCPM <a @click="sortData(rawData, 'today', 'ecpm')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'ecpm')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag
              effect="dark"
              size="small"
              :type="
                formatData(scope.row.today.ecpm ?? 0) > 95 ? 'danger' : ''
              "
              >{{ formatData(scope.row.today.ecpm ?? 0) }}</el-tag
            >
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              formatData(scope.row.yesterday.ecpm ?? 0)
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #bottom> </template>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import getIncome from "@/api/getIncome.js";
import { formatTime } from "@/utils/time.js";
import { getLATime, getDay } from "@/utils/time.js";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      selectTime: "",
      rawData: [],
      formatTime,
      tableData: [],
      isLoading: false,
      getLATime: getLATime,
      getDay: getDay,
    };
  },
  methods: {
    async requestData(params) {
      this.isLoading = true;
      try {
        const res = await getIncome(params);
        this.isLoading = false;
        this.rawData = res;
        this.sortData(res, "today", "money");
        console.log(res);
      } catch (error) {
        console.error(error)
        this.isLoading = false;
      }
    },
    formatData(num) {
      return num ? parseFloat(num).toFixed(2) : num;
    },
    sortData(list, day, type) {
      this.tableData = list.sort((a, b) => {
        if (day) {
          return parseFloat(b[day][type] ?? 0) - parseFloat(a[day][type] ?? 0);
        } else {
          return parseFloat(b[type] ?? 0) - parseFloat(a[type] ?? 0);
        }
      });
    },
    search() {
      console.log(this.selectTime);
      if (this.selectTime) {
        this.requestData({ queryDate: this.selectTime });
      } else {
        this.$message({
          showClose: true,
          message: "请选择日期",
          type: "error",
        });
      }
    },
  },
  mounted() {
    this.requestData();
  },
  computed: {
    totalToday() {
      return this.rawData.reduce((previousValue, currentValue) => {
        return parseFloat(currentValue.today.money ?? 0) + previousValue;
      }, 0);
    },
    yesterdayToday() {
      return this.rawData.reduce((previousValue, currentValue) => {
        console.log(currentValue.yesterday.money);
        return parseFloat(currentValue.yesterday.money ?? 0) + previousValue;
      }, 0);
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  span {
    font-size: 24px;
  }
  .el-divider--vertical {
    vertical-align: unset;
  }
}

.el-table .cell {
  a {
    color: #409eff;
  }
}

.el-divider--vertical {
  margin: 0 4px;
}
</style>
